import { render } from "./ProductRegistrationVerifyBike.vue?vue&type=template&id=1c5e379b"
import script from "./ProductRegistrationVerifyBike.vue?vue&type=script&lang=js"
export * from "./ProductRegistrationVerifyBike.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__